/* istanbul ignore file */

import { h, render } from 'preact';
import GAnalytics from 'ganalytics';
import './index.sass';
import App from './scripts/views/index';

function init() {
    render(<App />, document.body, document.getElementById('root'));
}

init();

if (process.env.NODE_ENV === 'production') {
	// add Google Analytics
	window.ga = new GAnalytics('UA-XXXXXXXX-X');
} else {
	// use preact's devtools
	require('preact/devtools');
	// listen for HMR
	if (module.hot) {
		module.hot.accept('./scripts/views', init);
	}
}



// WEBPACK FOOTER //
// ./src/index.js